export default function max (a, b) {
  return Math.max(a, b)
}
